import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import { PronosticoHistoricoInterface, PronosticoHistoricoService } from '@/domain/services/PronosticoHistoricoService'
import { PronosticoHistoricoState, StoreError } from './types'

const pronosticoHistorico: PronosticoHistoricoInterface = new PronosticoHistoricoService()

export const actions: ActionTree<PronosticoHistoricoState, RootState> = {
  async getPronosticoHistorico ({ commit }) {
    try {
      const actionResponse = await pronosticoHistorico.getPronosticoHistorico()
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  async getLinkDescarga ({ commit }, { estacionId, fecha }): Promise<any> {
    try {
      const actionResponse = await pronosticoHistorico.getLinkDescarga(estacionId, fecha)
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  deletePronosticoHistorico ({ commit }) {
    return commit('PRONOSTICO_HISTORICO_DELETED', undefined)
  }
}
